<template lang="pug">
    v-dialog(
    v-model="popupDialog"
    transition="dialog-bottom-transition"
    width="35%"
    content-class="dialog"
    )
        v-card
            v-toolbar(dense flat color="accent white--text" height="50px")
                v-fade-transition(mode="out-in")
                    v-toolbar-title Delete Quick Link Section

                v-spacer
                v-btn(icon @click.native="popupDialog = false")
                    v-icon close
            v-container
                v-layout(row wrap delete-msg)
                    v-flex(xs12 sm6 md11 flex-1)
                        span Are you sure you want to Delete? Deleting this Section is permanent.
                v-layout(row wrap)
                    v-flex(xs12 sm12 md11 flex-1)
                        v-btn(
                        flat
                        @click.native="deleteQuickLinkSection"
                        id="deleteSectionBtn"
                        :disabled="deleteClicked"
                        ).button-delete-quick-link Delete
                        v-btn(flat
                        @click.native="popupDialog = false").button-delete-cancel Cancel
</template>

<script>
import Base from '@/components/views/Base';

export default {
    name: 'DeleteSectionModuleDialog',
    extends: Base,

    props: {
        showDialog: { type: Boolean, default: false },
        index: { type: Number, default: -1 }
    },

    data() {
        return {
            popupDialog: false,
            deleteClicked: false
        };
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.popupDialog = true;
            }
        },

        popupDialog(value) {
            if (!value) {
                this.$emit('closed');
            }
        },

    },

    methods: {
        async deleteQuickLinkSection() {
            try {
                this.deleteClicked = true;
                this.$emit('deleteQuickLinkSection', this.index);
            } catch (err) {
                console.log(err);
                this.showErrorAlert(err.message);
            } finally {
                this.popupDialog = false;
                this.deleteClicked = false;
            }
        }
    }
};
</script>

<style scoped>
    .button-delete-quick-link {
        font-weight:bold;
        background-color: var(--v-secondary-base);
        color: white !important;
    }
    .button-delete-cancel {
        color: var(--v-secondary-base) !important;
        border:1px solid var(--v-secondary-base);
    }
    .delete-msg{
        margin-bottom:20px;
        font-weight: bold;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/dashboard/DeleteSectionModuleDialog.vue